// FormVatTypeSelect Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import _ from 'lodash'

import IntlUtil from '../../../lib/intlutil.jsx'

class FormVatTypeSelect extends Component {
  static get propTypes () {
    return {
      item: PropTypes.object,
      isQuickbookConnected: PropTypes.bool,
      name: PropTypes.string,
      value: PropTypes.string,
      quickbookItems: PropTypes.array,
      disabled: PropTypes.bool,
      onBlur: PropTypes.func,
      onInputKeyDown: PropTypes.func,
      reloadQuickbookItems: PropTypes.func,
      onChange: PropTypes.func,
      showReloadOption: PropTypes.bool,
      classNamePrefix: PropTypes.string,
      className: PropTypes.string,
      components: PropTypes.any
    }
  }

  static get defaultProps () {
    return {
      item: null,
      isQuickbookConnected: false,
      name: '',
      value: '',
      quickbookItems: [],
      disabled: false,
      onBlur: null,
      onInputKeyDown: null,
      reloadQuickbookItems: null,
      onChange: null,
      classNamePrefix: 'typeitem',
      showReloadOption: true,
      className: '',
      components: null
    }
  }

  render () {
    const {
      name,
      value,
      quickbookItems,
      isQuickbookConnected,
      disabled,
      className,
      classNamePrefix,
      onBlur,
      onInputKeyDown,
      components,
      showReloadOption
    } = this.props
    let options = this._getDefaultLabelTypes()

    if (isQuickbookConnected) {
      options = quickbookItems.map(item => {
        return { label: item.name, value: item.quickbookId }
      })

      options.unshift({
        label: IntlUtil.convertMessage('project.viewBudget.typeNone'),
        value: ''
      })
      if (showReloadOption) {
        options.push({
          label: IntlUtil.convertMessage(
            'project.viewBudget.typeReloadQuickbookItems'
          ),
          value: '__reload__'
        })
      }
    }

    return (
      <div className='value infoservice'>
        <ReactSelect
          name={name}
          value={_.find(options, obj => obj.value === value) || null}
          className={
            className ||
            `select-alt${
              disabled ? ' disable' : ''
          } select-type select-bugetitem`
          }
          options={options}
          components={components || {}}
          clearable={false}
          openOnFocus
          isDisabled={disabled}
          classNamePrefix={classNamePrefix}
          onChange={this._onChange.bind(this)}
          onBlur={onBlur}
          onInputKeyDown={onInputKeyDown}
        />
      </div>
    )
  }

  _getDefaultLabelTypes () {
    return [
      {
        label: IntlUtil.convertMessage('project.viewBudget.typeNone'),
        value: ''
      },
      {
        label: IntlUtil.convertMessage('project.viewBudget.typeService'),
        value: 'Service'
      },
      {
        label: IntlUtil.convertMessage('project.viewBudget.typeProduct'),
        value: 'Product'
      }
    ]
  }

  /* Event handlers */
  _onChange (selectedOption, ev) {
    if (selectedOption.value === '__reload__') {
      if (this.props.reloadQuickbookItems) {
        this.setState({ dataDate: new Date() })
        this.props.reloadQuickbookItems()
      }
    } else if (this.props.onChange) {
      this.props.onChange(selectedOption, ev)
    }
  }
}

export default FormVatTypeSelect
